import { render, staticRenderFns } from "./table_agendamentos_futuros.vue?vue&type=template&id=3b79de85"
import script from "./table_agendamentos_futuros.vue?vue&type=script&lang=js"
export * from "./table_agendamentos_futuros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports